import React, { useState } from 'react';

import Header from './Header';
import LeftSidebar from './LeftSidebar';

const BasicLayout = (props) => {
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  const handleBurgerClick = () => {
    setMobileMenuIsOpen(true);
  };

  const handleMenuClose = () => {
    setMobileMenuIsOpen(false);
  };

  const adminPanel = localStorage.getItem('adminPanel');

  return (
    <React.Fragment>
      {mobileMenuIsOpen && <div className="mask" onClick={handleMenuClose} />}
      <Header {...props} handleBurgerClick={handleBurgerClick} />
      <LeftSidebar
        {...props}
        mobileMenuIsOpen={mobileMenuIsOpen}
        handleMenuClose={handleMenuClose}
        adminPanel={adminPanel}
      />
      <div className="content-page" style={{ position: 'relative' }}>
        <div className="content">
          <div className="container-fluid">{props.children}</div>
        </div>
        {/* <Footer /> */}
      </div>
    </React.Fragment>
  );
};

export default BasicLayout;
